
import React, { useEffect, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';

let tvScriptLoadingPromise;


function TradingViewWidget(){
    const onLoadScriptRef = useRef();

    useEffect(
      () => {
        onLoadScriptRef.current = createWidget;
  
        if (!tvScriptLoadingPromise) {
          tvScriptLoadingPromise = new Promise((resolve) => {
            const script = document.createElement('script');
            script.id = 'tradingview-widget-loading-script';
            script.src = 'https://s3.tradingview.com/tv.js';
            script.type = 'text/javascript';
            script.onload = resolve;
  
            document.head.appendChild(script);
          });
        }
  
        tvScriptLoadingPromise.then(() => onLoadScriptRef.current && onLoadScriptRef.current());
  
        return () => onLoadScriptRef.current = null;
  
        function createWidget() {
          if (document.getElementById('tradingview_0e734') && 'TradingView' in window) {
            new window.TradingView.widget({
              autosize: true,
              symbol: "BSE:SENSEX",
              timezone: "Asia/Kolkata",
              theme: "light",
              style: "1",
              locale: "in",
              enable_publishing: false,
              range: "3M",
              hide_side_toolbar: false,
              allow_symbol_change: true,
              container_id: "tradingview_0e734"
            });
          }
        }
      },
      []
    );
    return(
        <>
    <Header></Header>
        <div className='tradingview-widget-container' style={{ height: "100%", width: "100%" }}>
      <div id='tradingview_0e734' style={{ height: "900px", width: "100%" }} />
      <div className="tradingview-widget-copyright">
        <a href="https://in.tradingview.com/" rel="noopener nofollow" target="_blank"><span className="blue-text">Track all markets on TradingView</span></a>
      </div>
    </div>
<Footer/>
        </>
    )
}
export default TradingViewWidget